'use client';

import { PageHeader } from '@eliadmin/core/src/components/homepage/page-header';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { CoursesFilterLeft } from '../../components/jobportal/courses/courses-filter-left';
import { JobportalCoursesHeader } from '../../components/jobportal/courses/jobportal-courses-header';
import {
  JobportalCoursesStoreProvider,
  JobportalCoursesFilterParamsSync,
} from '../../stores/jobportal-courses-store';
import {
  JobPortalCoursesContainer,
  JobPortalCoursesContainerSkeleton,
} from '../../components/jobportal/jobportal-courses-container';
import { getSlugFromPage } from '@eliadmin/core/src/utils/url-utils';
import { parseCourseFilters } from '../../stores/course-list-url';

export default function CoursesPage() {
  const searchParams = useSearchParams();
  const { t } = useTranslations();

  return (
    <>
      <PageHeader
        breadcrumb={{
          name: t('text1507'),
          slug: getSlugFromPage('courses'),
        }}
      />
      <JobportalCoursesStoreProvider
        state={{
          filter: parseCourseFilters(searchParams),
        }}
      >
        <JobportalCoursesFilterParamsSync />
        <Container className={cn('flex flex-col gap-8 py-8', 'ea-job-portal-courses__container')}>
          {/* <JobPortalOffersFilter /> */}
          <div className={cn('grid w-full grid-cols-12 gap-8', 'ea-job-portal-courses__grid')}>
            <div
              className={cn(
                'col-span-12 md:col-span-5 lg:col-span-3',
                'ea-job-portal-courses__filter',
              )}
            >
              <div className="hidden md:block">
                <CoursesFilterLeft />
              </div>
            </div>
            <div className={cn('col-span-12 md:col-span-7 lg:col-span-9', 'ea-job-portal-courses')}>
              <JobportalCoursesHeader />
              <Suspense fallback={<JobPortalCoursesContainerSkeleton />}>
                <JobPortalCoursesContainer showPagination />
              </Suspense>
            </div>
          </div>
        </Container>
      </JobportalCoursesStoreProvider>
    </>
  );
}
